import { useEffect, useState } from 'react';

import { MODAL_CLOSE_TIMEOUT } from 'Utils/utils';

const useDelayedClosed = (isOpen, ignoreDelayedClose) => {
	const [isClosed, setIsClosed] = useState(!isOpen);
	useEffect(() => {
		if (ignoreDelayedClose) {
			return undefined;
		}
		if (isOpen) {
			setIsClosed(false);
			return undefined;
		}
		const timeoutId = setTimeout(() => {
			setIsClosed(true);
		}, MODAL_CLOSE_TIMEOUT);
		return () => clearTimeout(timeoutId);
	}, [ignoreDelayedClose, isOpen]);

	return isClosed;
};

export default useDelayedClosed;
